<template>
    <div class="row">
        <div class="col-md-12">
            <h4>Souscrire à un programme de fidélité</h4>
            <p>
                <span>1 - Choisir un programme de fidélité : </span>
                <span v-for="(loyaltyProgram, index) in loyaltyPrograms" :key="index" @click="selectLoyaltyProgram(customerId, loyaltyProgram)" class="label label__lp" :class="isActiveLp(loyaltyProgram.id)">{{ loyaltyProgram.name }}</span>
            </p>
            <p v-if="newSubscriptionInfos !== null && newSubscriptionInfos.anticipated_points !== 0" class="alert alert-warning">
                <span>La commande n°{{ newSubscriptionInfos.last_booking_order.id }} du {{ newSubscriptionInfos.last_booking_order.created_at | moment-date }} donnerait droit à {{ newSubscriptionInfos.anticipated_points }} {{ newSubscriptionInfos.anticipated_points > 1 ? 'points' : 'point' }}</span>
            </p>
            <p v-else-if="newSubscriptionInfos !== null && newSubscriptionInfos.anticipated_points === 0" class="alert alert-warning">
                <span>La dernière commande du client ne lui permet pas de créditer des points de fidélité lors de son adhésion.</span>
            </p>
            <div v-if="newSubscriptionInfos !== null" class="checkbox checkbox-primary">
                2 -
                <input type="checkbox" class="checkbox" id="cgv" names="cgv" :checked="cgvCheckbox" required>
                <label for="cgv" @click="cgvCheckbox = !cgvCheckbox">
                    <span>Valider les</span>
                </label>
                <span class="text-success cgv-link" data-toggle="modal" data-target="#modalSlideUp">Conditions Générales de Vente</span>
                <br>
                <br>
                <span class="btn btn-success" v-show="cgvCheckbox" @click="subscribe(customerId, activeLp, cgvCheckbox)">SOUSCRIRE</span>
            </div>
        </div>

        <!-- CGV MODAL -->
        <div class="modal fade" id="modalSlideUp" tabindex="-1" role="dialog" aria-labelledby="modalSlideUpLabel" aria-hidden="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content-wrapper">
                    <div class="modal-content">
                        <div class="modal-header clearfix text-left">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                            <i class="pg-close fs-14"></i>
                            </button>
                            <h5>Conditions Générales de Vente <span class="semi-bold">FIDEL'LOC</span></h5>
                        </div>
                        <div class="modal-body">
                            <p v-if="newSubscriptionInfos !== null" v-html="newSubscriptionInfos.cgv"></p>
                            <button v-if="!cgvCheckbox" type="button" class="btn btn-primary" data-dismiss="modal" @click="cgvCheckbox = true">Valider les CGV</button>
                            <button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'subscribeToLP',

    data () {
        return {
            cgvCheckbox: false,
            activeLp: null
        }
    },

    created () {
        this.fetchLoyaltyPrograms()
    },

    computed: {
        ...mapState('lps', ['loyaltyPrograms', 'newSubscriptionInfos']),
        ...mapState('customer', {'customerId': 'id'})
    },

    methods: {
        ...mapActions('lps', ['fetchLoyaltyPrograms', 'fetchNewSubscriptionInfos', 'addNewLoyaltyProgramSubscription']),

        selectLoyaltyProgram (customerId, loyaltyProgram) {
            this.activeLp = loyaltyProgram.id
            this.fetchNewSubscriptionInfos({ customer_id: customerId, loyalty_program_id: loyaltyProgram.id})
        },

        isActiveLp (lpId) {
            return lpId === this.activeLp ? 'label-success' : ''
        },

        subscribe (customerId, activeLp, cgvCheckbox) {
            this.addNewLoyaltyProgramSubscription({ customer_id: customerId, loyalty_program_id: activeLp, accept_cgv: cgvCheckbox ? 1 : 0 })
        }
    }
}
</script>

<style lang="scss" scoped>
.label__lp {
    cursor: pointer;
}

.checkbox label {
    margin-right: 0;
}

.cgv-link {
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// client/components/Customer/LoyaltyProgram/LpsSubscription.vue